/** Склонение после числа: 1 форма / 2–4 (кроме 12–14) / остальное. */
export function pluralRu(
  n: number,
  forms: { one: string; few: string; many: string }
): string {
  const nMod100 = Math.abs(Math.trunc(n)) % 100;
  const nMod10 = nMod100 % 10;
  if (nMod100 >= 11 && nMod100 <= 14) return forms.many;
  if (nMod10 === 1) return forms.one;
  if (nMod10 >= 2 && nMod10 <= 4) return forms.few;
  return forms.many;
}
